/**
 * Sidebar — V3 glassmorphic replacement.
 *
 * The full V3 sidebar lives at src/Components/V3/Layout/V3Sidebar.jsx.
 * This file used to hold the V2 Bootstrap sidebar (~270 lines); now it's
 * a thin re-export so Layout.jsx's `import Sidebar from './Sidebar'`
 * continues to resolve.
 */
import V3Sidebar from '../../Components/V3/Layout/V3Sidebar';

export default V3Sidebar;
